(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 9435:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners",
      function () {
        return __webpack_require__(8195);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SEO_SEO; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./lib/seo-config.js
var SITE_CONFIG = {
    name: "Evry Health",
    url: "https://www.evryhealth.com",
    defaultOgImage: "https://www.evryhealth.com/og-image.png",
    twitterCard: "summary_large_image"
};
var PAGE_SEO = {
    "": {
        title: "Evry Health | Modern Health Insurance for Texas Employers & Members",
        description: "Evry Health offers transparent, member-first health insurance for Texas employers (51+ employees) and their members — with $0 telehealth, no copays, no deductibles, and a personalized care team.",
        ogDescription: "Transparent, member-first health insurance for Texas employers and members. No copays. No deductibles. $0 telehealth.",
        twitterTitle: "Evry Health",
        twitterDescription: "Modern health insurance for Texas employers and members."
    },
    "admission-notification": {
        title: "Inpatient Admission Notification | Evry Health",
        description: "How to submit inpatient admission notifications to Evry Health to ensure timely, accurate claims processing.",
        ogDescription: "How to submit inpatient admission notifications to Evry Health.",
        twitterTitle: "Admission Notification | Evry Health",
        twitterDescription: "Submit inpatient admission notifications to Evry Health."
    },
    careers: {
        title: "Careers at Evry Health | Join Our Team",
        description: "We're making health insurance work again. Explore open roles at Evry Health in Dallas, Texas.",
        twitterTitle: "Careers at Evry Health",
        twitterDescription: "Explore open roles at Evry Health in Dallas, Texas."
    },
    "community-resources": {
        title: "Texas Community Resources for Members | Evry Health",
        description: "A curated list of local community, health, food, and legal resources across Texas for Evry Health members.",
        twitterTitle: "Texas Community Resources | Evry Health",
        twitterDescription: "Community, health, food, and legal resources for Evry Health members in Texas."
    },
    "contact-us": {
        title: "Contact Evry Health | Get a Quote",
        description: "Get in touch with Evry Health for plan quotes, member support, or general questions. Call 1-855-579-3879.",
        ogDescription: "Get in touch with Evry Health for plan quotes, member support, or general questions.",
        twitterTitle: "Contact Evry Health",
        twitterDescription: "Get a quote or ask us anything. Call 1-855-579-3879."
    },
    faqs: {
        title: "Frequently Asked Questions | Evry Health",
        description: "Answers to common questions about Evry Health plans, coverage, virtual care, and member benefits.",
        twitterDescription: "Answers to common questions about Evry Health plans and coverage."
    },
    forms: {
        title: "Forms & Notices | Evry Health",
        description: "Download member and provider forms, notices, and resources from Evry Health.",
        twitterDescription: "Download forms and notices from Evry Health."
    },
    fwa: {
        title: "Report Fraud, Waste & Abuse | Evry Health",
        description: "How Evry Health members and providers can report suspected fraud, waste, or abuse.",
        twitterDescription: "Report suspected fraud, waste, or abuse to Evry Health."
    },
    "how-we-compare": {
        title: "How Evry Health Compares | Plan Comparison",
        description: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care, and transparent premiums.",
        ogDescription: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care.",
        twitterTitle: "How Evry Health Compares",
        twitterDescription: "Compare Evry Health plans against traditional carriers."
    },
    "how-we-do-it": {
        title: "How Evry Health Works | Built for Modern Workforces",
        description: "Evry Health is built for the modern business and the mobile workforce. See how our health insurance plans work.",
        twitterTitle: "How Evry Health Works",
        twitterDescription: "Built for the modern business and the mobile workforce."
    },
    "join-the-evry-network": {
        title: "Join the Evry Health Provider Network",
        description: "Apply to join the Evry Health provider network. Faster payments. Transparent terms.",
        twitterTitle: "Join the Evry Health Network",
        twitterDescription: "Apply to join the Evry Health provider network."
    },
    login: {
        title: "Sign In | Evry Health",
        description: "Sign in to the Evry Health member portal.",
        noindex: true
    },
    "meet-your-new-team": {
        title: "Meet Your Evry Health Care Team",
        description: "Every Evry Health member gets a dedicated team of nurses, nutritionists, and doctors — included at no extra cost.",
        ogDescription: "Every member gets a dedicated team of nurses, nutritionists, and doctors — at no extra cost.",
        twitterDescription: "A dedicated team of nurses, nutritionists, and doctors — included at no extra cost."
    },
    members: {
        title: "Member Registration | Evry Health",
        description: "Register for your Evry Health member portal account.",
        noindex: true
    },
    mobileapp: {
        title: "Evry Health Mobile App | Manage Your Plan On the Go",
        description: "Download the Evry Health mobile app to view your ID card, find providers, message your care team, and more.",
        ogDescription: "Download the Evry Health mobile app to view your ID card, find providers, and message your care team.",
        twitterTitle: "Evry Health Mobile App",
        twitterDescription: "Manage your health plan on the go with the Evry Health app."
    },
    news: {
        title: "News & Press | Evry Health",
        description: "The latest news, press releases, and announcements from Evry Health.",
        twitterDescription: "The latest news and announcements from Evry Health."
    },
    "non-discrimination-policy": {
        title: "Non-Discrimination Policy | Evry Health",
        description: "Evry Health's commitment to non-discrimination and language assistance for members.",
        twitterDescription: "Non-discrimination and language assistance for all members."
    },
    "our-story": {
        title: "Our Story | Evry Health",
        description: "Evry Health is on a mission to build the health insurance company we've always wanted for ourselves.",
        ogDescription: "We're on a mission to build the health insurance company we've always wanted for ourselves.",
        twitterDescription: "Building the health insurance company we've always wanted."
    },
    partners: {
        title: "Partners | Evry Health",
        description: "The partners and providers Evry Health works with to deliver modern health insurance.",
        twitterDescription: "Partners and providers delivering modern health insurance."
    },
    "prior-auth-list-updates": {
        title: "Prior Authorization List Updates | Evry Health",
        description: "Recent updates to the Evry Health prior authorization list for providers.",
        twitterDescription: "Recent updates to the prior authorization list for providers."
    },
    "prior-auth-tool": {
        title: "Prior Authorization Tool | Evry Health for Providers",
        description: "Look up whether a procedure requires prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization Tool | Evry Health",
        twitterDescription: "Check if prior authorization is required for a procedure."
    },
    "prior-authorization": {
        title: "Prior Authorization | Evry Health for Providers",
        description: "Information for providers on which procedures require prior authorization with Evry Health.",
        ogDescription: "Provider resources for prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization | Evry Health",
        twitterDescription: "Provider resources for prior authorization with Evry Health."
    },
    "privacy-policy": {
        title: "Privacy Policy | Evry Health",
        description: "How Evry Health collects, uses, and protects your personal and health information.",
        twitterDescription: "How Evry Health protects your personal and health information."
    },
    providerdirectory: {
        title: "Provider Directory | Evry Health",
        description: "Find in-network providers with the Evry Health provider directory.",
        noindex: true
    },
    "request-to-join": {
        title: "Request to Join | Evry Health Network",
        description: "Submit a request to join the Evry Health provider network. Simple application process.",
        ogDescription: "Submit a request to join the Evry Health provider network.",
        twitterTitle: "Request to Join | Evry Health",
        twitterDescription: "Join the Evry Health provider network."
    },
    "retrospective-reviews": {
        title: "Retrospective Reviews | Evry Health for Providers",
        description: "Learn how Evry Health determines coverage after treatment has been provided.",
        twitterTitle: "Retrospective Reviews | Evry Health",
        twitterDescription: "How Evry Health determines coverage after treatment."
    },
    rewards: {
        title: "Member Rewards | Evry Health",
        description: "Earn rewards for staying healthy as an Evry Health member.",
        twitterDescription: "Earn rewards for staying healthy with Evry Health."
    },
    terms: {
        title: "Terms of Use | Evry Health",
        description: "Terms of use for the Evry Health website and digital services.",
        twitterDescription: "Terms of use for Evry Health website and services."
    },
    "virtual-care": {
        title: "$0 Virtual Care & Telehealth | Evry Health",
        description: "Talk to a board-certified physician 24/7 for $0. On-demand virtual care included with every Evry Health plan.",
        twitterDescription: "Talk to a board-certified physician 24/7 for $0."
    },
    "why-choose-evry": {
        title: "Why Choose Evry Health | Texas Health Insurance",
        description: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth, and a personalized member care team.",
        twitterTitle: "Why Choose Evry Health",
        twitterDescription: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth."
    }
};
function getPageSeo(slug) {
    var page = PAGE_SEO[slug] || {};
    var title = page.title || SITE_CONFIG.name;
    var description = page.description || "";
    var ogTitle = page.ogTitle || title;
    var ogDescription = page.ogDescription || description;
    var ogImage = page.ogImage || SITE_CONFIG.defaultOgImage;
    var twitterTitle = page.twitterTitle || ogTitle;
    var twitterDescription = page.twitterDescription || ogDescription;
    var twitterImage = page.twitterImage || ogImage;
    var noindex = page.noindex || false;
    var url = slug === "" ? "".concat(SITE_CONFIG.url, "/") : "".concat(SITE_CONFIG.url, "/").concat(slug);
    return {
        title: title,
        description: description,
        url: url,
        ogTitle: ogTitle,
        ogDescription: ogDescription,
        ogImage: ogImage,
        twitterTitle: twitterTitle,
        twitterDescription: twitterDescription,
        twitterImage: twitterImage,
        noindex: noindex
    };
}

;// CONCATENATED MODULE: ./components/SEO/SEO.js





var SEO = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slug = ref.slug, overrides = ref.overrides;
    var router = (0,next_router.useRouter)();
    var resolvedSlug = slug !== undefined ? slug : router.pathname.replace(/^\//, "");
    var resolved = getPageSeo(resolvedSlug);
    var seo = overrides ? (0,_object_spread/* default */.Z)({}, resolved, overrides) : resolved;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: seo.ogTitle
            }, "title"),
            seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex,follow"
            }),
            !seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: SITE_CONFIG.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: seo.ogDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: seo.ogImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: SITE_CONFIG.twitterCard
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: seo.twitterTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: seo.twitterDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: seo.twitterImage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SEO_SEO = (SEO);


/***/ }),

/***/ 8195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ partners; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./layout/Layout.js + 6 modules
var Layout = __webpack_require__(9875);
// EXTERNAL MODULE: ./components/SEO/SEO.js + 1 modules
var SEO = __webpack_require__(3976);
;// CONCATENATED MODULE: ./components/PartnersAccordian/PartnersAccordian.js

var PartnersAccordian = function(props) {
    var companyLogo = props.companyLogo, companyLogoAltText = props.companyLogoAltText, companySummary = props.companySummary, statistics = props.statistics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-1 md:grid-cols-12 px-4 md:px-0 py-6 md:py-16 gap-6 border-t-2 border-white last:border-b-2 last:border-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:col-span-3 px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: companyLogo,
                        alt: companyLogoAltText
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:col-span-9 grid md:grid-cols-3 gap-4 text-grey gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:col-span-3 pb-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: companySummary
                            })
                        }),
                        statistics.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:col-span-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: item
                                    }
                                })
                            }, index);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var PartnersAccordian_PartnersAccordian = (PartnersAccordian);

;// CONCATENATED MODULE: ./components/PartnersAccordian/consts.js
// @ts-check
// /**
//  * @typedef {{
//  *  companyLogo: string,
//  *  companyLogoAltText: string,
//  * companySummary: string,
//  * statistics: []<string>
//  * }} PartnerCompanyInfo
//  */
// /**
//  * @type {Map<string,PartnerCompanyInfo>}
//  */
var partnerCompanyInfo = [
    {
        companyLogo: "/omada.png",
        companyLogoAltText: "Omada Company Logo",
        companySummary: "Omada provides a personalized program for managing diabetes, hypertension, weight loss, as well as joint and muscle pain. Members receive dedicated coaches, smart devices, interactive lessons, and more to help create long-term results through behavior change.",
        statistics: [
            '<span className="text-blue font-bold"><span className="text-3xl block">79%</span> of Prevention Program participants </span>felt increased satisfaction towards their employer',
            '<span className="text-blue font-bold"><span className="text-3xl block">99%</span> of MSK Program participants </span>are satisfied with the care of the program',
            '<span className="text-blue font-bold"><span className="text-3xl block">76%</span> of Diabetes &#38; Hypertension Program participants </span>meet A1C reduction goals in the program', 
        ]
    },
    {
        companyLogo: "/meru-health.png",
        companyLogoAltText: "Meru Health Logo",
        companySummary: "Meru combines therapist and psychiatrist support, chat-based coaching, virtual workshops, evidence-based digital content, biofeedback wearables, anonymous peer support, meditation practices, and more into a clinically proven 12-week treatment program that will transform your employees&#39; mental health.",
        statistics: [
            '<span className="text-blue font-bold"><span className="text-3xl block">75%</span> of participants</span> reach depression or anxiety remission after program',
            '<span className="text-blue font-bold"><span className="text-3xl block">85%</span> of participants</span> show clinically significant improvement',
            '<span className="text-blue font-bold"><span className="text-3xl block">89%</span> completion rate</span> with significant symptom reduction', 
        ]
    },
    {
        companyLogo: "/maven.png",
        companyLogoAltText: "Maven Logo",
        companySummary: "As part of the Women’s Health care plan, Maven provides support for fertility, pregnancy, postpartum and parenthood. This is a family benefits solution with comprehensive, patient-first support on a modern platform.",
        statistics: [
            '<span className="text-blue font-bold"><span className="text-3xl block">20%</span> lower</span> c-section rates',
            '<span className="text-blue font-bold"><span className="text-3xl block">32%</span> lower</span> NICU admission rates',
            '<span className="text-blue font-bold"><span className="text-3xl block">90%</span> of visits</span> are with specialists rather than OB/GYNs', 
        ]
    },
    {
        companyLogo: "/quit-genius.png",
        companyLogoAltText: "Quit Genius Logo",
        companySummary: "Digital clinic that delivers comprehensive medication-assisted treatment programs for addiction, tobacco, alcohol, and opioids. QuitGenius combines cognitive behavioral therapy and medications to drive holistic and sustained behavior changes.",
        statistics: [
            '<span className="text-blue font-bold"><span className="text-3xl block">88%</span> member</span> activation rate',
            '<span className="text-blue font-bold"><span className="text-3xl block">52%</span>tobacco</span> quit rate',
            '<span className="text-blue font-bold"><span className="text-3xl block">73%</span> of participants</span> reach alcohol abstinence or drinking below safe limit', 
        ]
    },
    {
        companyLogo: "/dr-on-demand.png",
        companyLogoAltText: "Dr On Demand Logo",
        companySummary: "With 24/7 access to top doctors, psychiatrists, psychologists, therapists, and other medical experts, members can receive world-class care anywhere within moments. Everyday & Urgent Care services are available within minutes and Behavioral Health services within only a couple days for the first appointment. These providers can write prescriptions, order lab work, help members find specialized follow-up care from an in-network doctor if necessary, and much more to help ensure Evry members have their physical and mental health needs met.",
        statistics: [
            '<span className="text-blue font-bold"><span className="text-3xl block">95%</span> successful</span> case resolution rate',
            '<span className="text-blue font-bold"><span className="text-3xl block">63%</span> reduction</span> in ER visits',
            '<span className="text-blue font-bold"><span className="text-3xl block">4.5/5</span> member</span> rating', 
        ]
    },
    {
        companyLogo: "/propeller.png",
        companyLogoAltText: "Propeller Logo",
        companySummary: "Propeller and their parent company, ResMed, are leaders in digital health and therapeutics for asthma and COPD, supporting patients in managing their condition with FDA cleared medical devices, consumer apps and access to clinical data for provider monitoring throughout the care journey.",
        statistics: [
            '<span className="text-blue font-bold"><span className="text-3xl block">79%</span> of patients</span> reported being very satisfied by program',
            '<span className="text-blue font-bold"><span className="text-3xl block">57%</span> reduction</span> in hospitalizations over 12 months',
            '<span className="text-blue font-bold"><span className="text-3xl block">78%</span> reduction</span> in daily rescue inhaler usage', 
        ]
    },
    {
        companyLogo: "/clickotine.png",
        companyLogoAltText: "Clickotine Logo",
        companySummary: "Clickotine provides personalized quit plans and monitoring with scientifically backed strategies to help overcome cravings, withdrawals, slips, and lapses. Combined with medication adherence programs and financial incentives, Clickotine offers improved member outcomes and cost savings.",
        statistics: [
            '<span className="text-blue font-bold"><span className="text-3xl block">45.2%</span> of participants</span> successfully stop smoking',
            '<span className="text-blue font-bold"><span className="text-3xl block">100.6</span> participants</span>',
            '<span className="text-blue font-bold"><span className="text-3xl block">214.6</span> average</span> completed interactions', 
        ]
    }, 
];

;// CONCATENATED MODULE: ./pages/partners.js





var Partners = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 h-1/2 bg-gray-100"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "h-full w-full object-cover",
                                                src: "dfwSkyline.png",
                                                alt: "Dallas-Fort Worth skyline"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative px-4 py-16 md:py-16 lg:py-32 max-w-screen-xl mx-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                    className: "text-3xl md:text-5xl tracking-tight text-darkBlue",
                                                    children: [
                                                        "Partners",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-globeGreen",
                                                            children: "you can trust"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-6 max-w-lg text-xl text-grey sm:max-w-3xl",
                                                    children: "The following programs are available to Evry members who meet the relevant clinical acceptance criteria. These services are paid for entirely by Evry Health as part of a broader effort to improve the health and wellness of our membership."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "max-w-screen-xl mx-auto py-8 md:py-24",
                        children: partnerCompanyInfo.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersAccordian_PartnersAccordian, {
                                companyLogo: item.companyLogo,
                                companyLogoAltText: item.companyLogoAltText,
                                companySummary: item.companySummary,
                                statistics: item.statistics
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var partners = (Partners);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87,875,774,888,179], function() { return __webpack_exec__(9435); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);